import { render, staticRenderFns } from "./TheAuthFacebook.vue?vue&type=template&id=3b0191e7&"
import script from "./TheAuthFacebook.vue?vue&type=script&lang=js&"
export * from "./TheAuthFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports